var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81818 11.1739H6.08696C3.27751 11.1739 1 8.89641 1 6.08696V6.08696C1 3.27751 3.27751 1 6.08696 1H13.913C16.7225 1 19 3.27751 19 6.08696V6.81028C19 9.22025 17.0463 11.1739 14.6364 11.1739V11.1739H10.8182M10.8182 11.1739L13.5455 8.34783M10.8182 11.1739L13.5455 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.05e4d6c5dde0e2762acf8e464dc1c7e4.svg";
export { ForwardRef as ReactComponent };